import React from "react";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MuiAccordion from "@material-ui/core/Accordion/Accordion";
import MuiAccordionSummary from "@material-ui/core/AccordionSummary/AccordionSummary";
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import Checkbox from '@material-ui/core/Checkbox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import {addItem, deleteItem, setChangedItem} from "../store/actions/cart_actions";
import {connect} from 'react-redux';
import {
    action_catalog,
    apiURL,
    contractId,
    CORSSupport,
    userID,
    userLogin,
    userPassword
} from "../configurationConstant";
import {QR} from "./CatalogItem";

const delete_button = require('../images/delete_button.png');

export const ServicePosition = (service_count, type, name, price, buttonClick, textChange, item) => {
    let classname = '';
    if(type === 0){
        classname = 'refund_cart'
    }
    return(
        <div className={"cart_description_field " + classname} key={name}>
            <p>{name}</p>
            <div className={'cart_description_field_info'}>
                <p><span>₽</span> {Number(price).toFixed(2)}</p>
                <p>5344657 шт. в наличии</p>
                <div>
                    <button className={'cart_description_field_button'} onClick={() => buttonClick(type, false, item)}>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            width="0.176cm" height="0.318cm">
                            <image  x="0px" y="0px" width="5px" height="9px"  xlinkHref="data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAJCAQAAABQpC4VAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QA/4ePzL8AAAAHdElNRQfkCBQQBzjVb/UUAAAAJElEQVQI12NggIH/jDAGAwMjjAFh/odIMMIYaKIoahkQMlAOALU+CP+4DUv6AAAAAElFTkSuQmCC" />
                        </svg>
                    </button>
                    <input className={'input_number'} type={'number'} placeholder={service_count !== 0? '':service_count} value={service_count === 0? '':service_count} onChange={e => textChange(e, type, item)}/>
                    <input className={'input_text'} type={'text'}  placeholder={service_count !== 0? '':service_count} value={service_count === 0? '':service_count} onChange={e => textChange(e, type, item)}/>
                    <button className={'cart_description_field_button'} onClick={() => buttonClick(type, true, item)}>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            width="0.176cm" height="0.318cm">
                            <image  x="0px" y="0px" width="5px" height="9px"  xlinkHref="data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAJCAQAAABQpC4VAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QA/4ePzL8AAAAHdElNRQfkCBQQCRR5NLR5AAAAKklEQVQI11XLOQ4AMAgDwYH//5kUwYqylU/G0sQ0Mb3tUP/2UpGVtLw3HHYUBgulENztAAAAAElFTkSuQmCC" />
                        </svg>
                    </button>
                </div>
                <p>{(price * service_count).toFixed(2)}</p>
            </div>
        </div>
    )
};

class CartItem extends React.Component{
    constructor(props){
        super(props);
        this.handleChangeField = this.handleChangeField.bind(this);
        this.Checkboxes = this.Checkboxes.bind();
        this.buttonChangeValue = this.buttonChangeValue.bind(this);
        this.deletePosition = this.deletePosition.bind(this);
        this.setChangeField = this.setChangeField.bind(this);
        this.isChanged = this.isChanged.bind(this);
        this.setServiceCount = this.setServiceCount.bind(this);
        this.getItem = this.getItem.bind(this);
        this.setItem = this.setItem.bind(this);
        this.state ={
            services: this.props.item.services,
            refund: this.props.item.refund,
            loaded: false,
            price: 0
        }

    }

    componentDidMount(){
        this.getItem(this.props.item.id)
    }

    getItem(id) {
        let headers = new Headers();
        headers.append('Content-Type','application/x-www-form-urlencoded');
        fetch( apiURL  , {
            method: "post",
            headers: headers,
            body: 'action=' + action_catalog + '&contract=' + contractId +'&log='+userLogin+'&pwd='+userPassword+'&user=' + userID + '&catalog=' + id,
            mode: 'cors',
        }).then(r => {
            if (r.status === 200){
                return r.json().then((data) => {
                    let count = 0;
                    this.props.item.services.forEach(el =>{
                        count += el.count;
                    });
                    this.setState({
                        data: data['catalog.position'],
                        loaded: true,
                        price: (Number(data['catalog.position'].services[0].service_price) + Number(data['catalog.position'].services[0].material_price) * (count))
                    })
                })
            }
        }).catch(r => console.log(r));
    }

    buttonChangeValue(type, plus, position){
        let count = 0;
        switch (type) {
            case 0:{
                count = this.state.refund;
                if (plus)count++;
                else if (count >0) count--;
                this.setState({refund: count});
                this.setItem(this.state.services, count);
                break;
            }
            case 1: {
                let services = this.state.services.filter(item =>{
                    return item.id !== position.id;
                });
                count = position.count;
                if (plus)count++;
                else if (count >0) count--;
                services.push({id: position.id, count: count, price: position.price});
                this.setState({services: services});
                this.setItem(services, this.state.refund);
                break;
            }
        }
    }

    handleChangeField = () => (event, newExpanded) => {
        newExpanded ?this.setState({expanded: false}): this.setState({expanded: false})
    };

    setChangeField(id, flag){
        this.props.setChangedItem(id,flag);
    }

    Checkboxes = (id) => {
        return(
            <Checkbox
                className={'checkbox'}
                style={{width: 20, height: 20, padding: 0, color: '#00B63A'}}
                checked={this.isChanged(id)}
                onChange={() =>{this.props.setChangedItem(id)}}
                icon={<CheckBoxOutlineBlankIcon style={{fontSize: 20}}/>}
                checkedIcon={<CheckBoxIcon style={{fontSize: 20}}/>}/>
        )
    };

    setItem(services, refund){
        this.setState({services: services, refund: refund});
        this.props.addItem({id: this.props.item.id, services:services, price: this.state.price, refund: refund});
    }

    deletePosition(id){
        this.props.deleteItem(id);
    }

    isChanged(id){
        let items = this.props.cart.chooses_items;
        return items.indexOf(id) !== -1;
    }

    setServiceCount(event, type, position){
        let count = 0;
        if (event.target.value !== ''){
            if (/^[0-9]+$/.test(event.target.value)) {
                count = Number(event.target.value);
            }
        }
        switch (type) {
            case 0:{
                this.setItem(this.state.services, count)
                break;
            }
            case 1: {
                let services = this.state.services.filter(item =>{
                    return item.id !== position.id;
                });
                services.push({id: position.id, count: count, price: position.price })
                this.setItem(services, this.state.refund);
                break;
            }
        }
    }

    render(){
        const {item,cart} = this.props;
        let expanded = document.documentElement.clientWidth >= 1200? true:undefined;
        let price = 0;
        let count = 0;
        this.state.services.forEach(item=>{
            price += item.count * item.price;
            count += item.count;
        });
        let head_count = 0;
        this.props.cart.cart_items.map(element => {
            if (Number(element.id) === Number(this.props.item.id)){
                element.services.map(service =>{
                    head_count += service.count;
                })
            }
        });
        return(
            <div>{this.state.loaded ? (
                <MuiAccordion square className={'cart_item'} expanded={expanded}>
                    <MuiAccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                    >
                        <div className={'cart_item_header'}>
                            <FormControlLabel
                                style={{paddingLeft:8}}
                                aria-label="Checkbox"
                                onClick={(event) => event.stopPropagation()}
                                onFocus={(event) => event.stopPropagation()}
                                control={this.Checkboxes(item.id)}
                                label={''}
                            />
                            <div className={'cart_item_header_info'} >
                                <div>
                                    <img src={QR} className={'catalog_qr'} alt={''}/>
                                    <p>{this.state.data.name}</p>
                                </div>
                                {/*4249320608710669130*/}
                                <div>
                                    <p><span>₽</span> {(price).toFixed(2)}</p>
                                    <p>{head_count} <span>шт.</span></p>
                                    <p>{(Number(this.state.data.services[0].service_price) + Number(this.state.data.services[0].material_price)).toFixed(2)}</p>
                                    <button onClick={() => this.deletePosition(this.state.data.catalogid)}>
                                        <img alt={''} src={delete_button}/>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </MuiAccordionSummary>
                    <MuiAccordionDetails onChange={this.handleChangeField('panel1')}>
                        <div style={{width: '100%', borderBottom: '1px dotted black'}}>
                            <div>
                                {this.state.data.services === 'no services'?undefined :this.state.data.services.map((item,index) =>{
                                    let position;
                                    try {
                                        position = this.state.services.filter(el => {
                                            return Number(el.id) === Number(item.catalog_service_id)
                                        })[0];
                                        if (position === undefined) {
                                            let count = 0;
                                            cart.cart_items.map(element => {
                                                if (Number(element.id) === Number(this.props.item.id)){
                                                    element.services.map(service =>{
                                                         count+=service.count;
                                                    })
                                                }
                                            });
                                            if (count === 0) count = head_count;
                                            position = {
                                                id: item.catalog_service_id,
                                                count:  count,
                                                price: Number(item.service_price)+ Number(item.material_price)
                                            }
                                        }
                                    }catch (e) { console.log(e); position = {id: item.catalog_service_id, count: 0, price: Number(item.service_price) + Number(item.material_price)}}
                                    return(
                                        ServicePosition(position.count, 1, item.service_name, Number(item.service_price)+Number(item.material_price), this.buttonChangeValue, this.setServiceCount, position)
                                    )
                                }
                                )}
                                {ServicePosition(this.state.refund, 0, 'Возврат отработанных картриджей', '', this.buttonChangeValue, this.setServiceCount)}
                                <div className={"cart_description_button"}>
                                    <button className={'favorites'}>
                                        <p>В избранное</p>
                                        {HearthIcon()}
                                    </button>
                                    <button onClick={() => this.deletePosition(this.state.data.catalogid)} className={'delete'}>
                                        <p>Удалить</p>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </MuiAccordionDetails>
                </MuiAccordion>
            ): undefined}
            </div>
        )
    }
}

export const HearthIcon = () => (
    <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.99999 12.2333L6.03333 11.3533C2.59999 8.24 0.333328 6.18 0.333328 3.66667C0.333328 1.60667 1.94666 0 3.99999 0C5.15999 0 6.27333 0.54 6.99999 1.38667C7.72666 0.54 8.83999 0 9.99999 0C12.0533 0 13.6667 1.60667 13.6667 3.66667C13.6667 6.18 11.4 8.24 7.96666 11.3533L6.99999 12.2333Z" fill="#86C3EE"/>
    </svg>
);

const mapStateToProps = store => {
    return{
        cart: store.cart,
    }
};

const mapDispatchToProps = dispatch => {
    return{
        setChangedItem: (id, flag) => dispatch(setChangedItem(id, flag)),
        deleteItem: (id) => dispatch(deleteItem(id)),
        addItem: (id) => dispatch(addItem(id)),
    }
};

export default connect(mapStateToProps,mapDispatchToProps)(CartItem)
